import { FC } from 'react';
import { Link } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useAiAgent } from 'contexts/AiAgentContext';
import { resolveNavigationRoute } from '../action-handlers/navigation';
import { CREATE_ROUTES, NavigationItem } from '../../types';
import TaskPrompt from './TaskPrompt';

type Props = {
  navigation: NavigationItem;
};

const NavigationTaskPrompt: FC<Props> = ({ navigation }) => {
  const history = useHistory();
  const { close } = useAiAgent();
  const resolvedRoute = resolveNavigationRoute(navigation.route);
  const isCreate = CREATE_ROUTES.has(navigation.route);

  const handleNavigate = () => {
    close();
    history.push(resolvedRoute);
  };

  return (
    <TaskPrompt
      icon={<Link sx={{ fontSize: 18, color: 'grey.500', flexShrink: 0 }} />}
      label={navigation.label}
      primaryAction={{
        label: isCreate ? 'Start' : 'Visit',
        onClick: handleNavigate,
      }}
      openInNewHref={resolvedRoute}
    />
  );
};

export default NavigationTaskPrompt;
